import instance from "./api";
import EndPoints from "./api-endpoints";

const ok = (r: any) => r;
const err = (e: any) => e.response;

export interface QuotableItemPayload {
  code?: string;
  name: string;
  kind: "PACKAGE" | "EXTRA";
  basePrice: number;
  taxCode?: string;
  description?: string;
  active?: boolean;
}

// ---- reads ----
const getQuotableItems = async () =>
  instance.get(EndPoints.getQuotableItems, { params: { activeOnly: false } }).then(ok).catch(err);

const getItems = async (itemClass?: string) =>
  instance.get(EndPoints.catalogueItems, { params: itemClass ? { itemClass } : {} }).then(ok).catch(err);

const getBranches = async () =>
  instance.get(EndPoints.catalogueBranches).then(ok).catch(err);

const getAudit = async (entityType?: string, entityKey?: string) =>
  instance
    .get(`${EndPoints.catalogueAdmin}/audit`, { params: { ...(entityType && { entityType }), ...(entityKey && { entityKey }) } })
    .then(ok)
    .catch(err);

// ---- quotable item CRUD ----
const createQuotableItem = async (payload: QuotableItemPayload) =>
  instance.post(`${EndPoints.catalogueAdmin}/quotable-items`, payload).then(ok).catch(err);

const updateQuotableItem = async (code: string, payload: QuotableItemPayload) =>
  instance.put(`${EndPoints.catalogueAdmin}/quotable-items/${code}`, payload).then(ok).catch(err);

const setQuotableItemPrice = async (code: string, price: number, reason?: string) =>
  instance.patch(`${EndPoints.catalogueAdmin}/quotable-items/${code}/price`, { price, reason }).then(ok).catch(err);

const deactivateQuotableItem = async (code: string) =>
  instance.delete(`${EndPoints.catalogueAdmin}/quotable-items/${code}`).then(ok).catch(err);

// ---- component item price ----
const setItemPrice = async (inventoryId: string, price: number, reason?: string) =>
  instance.patch(`${EndPoints.catalogueAdmin}/items/${inventoryId}/price`, { price, reason }).then(ok).catch(err);

// ---- branch letterhead / VAT / banking ----
/** Applies one VAT registration number to every branch; returns the number changed. */
const setVatNumberForAllBranches = async (vatNumber: string) =>
  instance.put(`${EndPoints.catalogueAdmin}/branches/vat-number`, { vatNumber }).then(ok).catch(err);

const updateBranch = async (
  branchId: string,
  payload: { name?: string; email?: string; addressLine1?: string; addressLine2?: string; city?: string; country?: string; primaryColor?: string; vatNumber?: string; active?: boolean },
) => instance.put(`${EndPoints.catalogueAdmin}/branches/${branchId}`, payload).then(ok).catch(err);

export {
  getQuotableItems,
  getItems,
  getBranches,
  getAudit,
  createQuotableItem,
  updateQuotableItem,
  setQuotableItemPrice,
  deactivateQuotableItem,
  setItemPrice,
  updateBranch,
  setVatNumberForAllBranches,
};
